<template>
  <v-card>
    <v-card-body>
      <v-card-title>Adresa livrare</v-card-title>
      <ul class="text-sm font-normal text-gray-600">
        <li>
          Persoana de contact: {{ order.billing_address?.first_name }},
          {{ order.billing_address?.last_name }}
        </li>
        <li>Adresa: {{ order.shipping_address?.street }}</li>
        <li>Tel: {{ order.shipping_address?.phone }}</li>
      </ul>
    </v-card-body>
  </v-card>
</template>

<script>
import VCard from "./VCard.vue";
import VCardBody from "./VCardBody.vue";
import VCardTitle from "./VCardTitle.vue";
export default {
  components: { VCard, VCardBody, VCardTitle },
  props: {
    order: {
      type: Object,
    },
  },
};
</script>

<style></style>
